var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardListStatusIcon2 = function SvgNewcsDashboardListStatusIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_list_status_icon2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M292 434h14v14h-14z",
    "data-name": "\\u77E9\\u5F62 335"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_list_status_icon2_svg__a)",
    transform: "translate(-292 -434)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fb835e",
    d: "M299.596 444.523h-1.2a.583.583 0 1 0 0 1.166h1.2a.583.583 0 1 0 0-1.166m4.8 2.331h-.6a6.93 6.93 0 0 0-2.4-4.908c-.368-.348-.84-.7-.84-.931s.357-.348.6-.47a5.89 5.89 0 0 0 2.637-5.369h.6a.58.58 0 0 0 .438-.164.54.54 0 0 0 .161-.429.54.54 0 0 0-.165-.422.58.58 0 0 0-.431-.161h-10.8a.58.58 0 0 0-.434.161.54.54 0 0 0-.165.422.54.54 0 0 0 .161.429.58.58 0 0 0 .438.164h.6a5.89 5.89 0 0 0 2.637 5.369c.242.123.6.358.6.47a7 7 0 0 1-.84 1.023 6.4 6.4 0 0 0-2.4 4.786h-.6a.591.591 0 0 0 0 1.176h10.8a.591.591 0 0 0 0-1.176Zm-9 0a5.9 5.9 0 0 1 2.038-4.09c.609-.583 1.208-1.166 1.208-1.749s-.483-1.023-1.05-1.4a4.68 4.68 0 0 1-2.2-4.438h7.206a4.68 4.68 0 0 1-2.164 4.438c-.6.348-1.05.7-1.05 1.4s.6 1.166 1.208 1.749a5.9 5.9 0 0 1 2.038 4.09Z",
    "data-name": 0
  }))));
};
export default SvgNewcsDashboardListStatusIcon2;